const locale = {
    "continue": "Weiter",
    "ok": "OK",
    "saveAll": "Alle Einstellungen speichern",
    "cancel": "Abbrechen",
    "yes": "ja",
    "no": "nein",
    "pa": "p.a.",
    "requiredFields": "* gekennzeichnete Felder sind Pflichtfelder.",
    "unknown.title": "Unbekannter Titel",
    "backToSpardaWebsite": "Zurück zur Sparda Website",
    "validFrom": "Gültig ab",
    "emailAddress": "E-Mail Adresse",
    "setting": "Einstellung",
    "value": "Wert",

    "error": "Fehler",
    "error.genericMessage": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später nochmal.",
    "error.requiredField": "Pflichtfeld",
    "error.ibanInvalid": "Keine gültige IBAN",
    "error.dateInvalid": "Kein gültiges Datum",
    "error.emailInvalid": "Keine gültige E-Mail Adresse",
    "error.phoneNumberInvalid": "Keine gültige Telefonnummer",
    "error.formatInvalid": "Ungültiges Format",
    "error.noCentValues": "Keine Cent-Beträge",
    "error.currencyInvalid": "Nur Ziffern (Centbeträge nach dem Komma z.B. 1000,50)",
    "error.interestInvalid": "Nur Ziffern (max 2 Nachkommastellen z.B. 1,24)",
    "error.loginFailed": "Login fehlgeschlagen",
    "error.passwordTooShort": "Mindestens 6 Zeichen",
    "error.upload": "Fehler beim Upload",
    "error.invalidLength": "Text zu kurz",
    "error.couldNotSendEmail": "Fehler beim E-Mail Versand. Ist {email} eine gültige E-Mail Adresse?",
    "error.loginForInterestRates": "Sie müssen eingelogged sein, um die Zinsen zu ändern.",
    "error.noChange": "Daten wurden nicht geändert",
    "error.onlyInt": "Nur ganze Zahlen",
    "validation.min": "Muss kleiner max. sein",
    "validation.max": "Muss größer min. sein",
    "validation.minValue": "Muss größer {value} sein",
    "validation.maxValue": "Muss kleiner {value} sein",
    "validation.minEqualsValue": "Muss größer gleich {value} sein",
    "validation.maxEqualsValue": "Muss kleiner gleich {value} sein",
    "validation.modByValue": "Muss durch {value} teilbar sein",
    "validation.isInt": "Muss Ganzzahl sein",

    "loanCalculator": "Kredit berechnen",
    "loanSummary": "Kreditdaten",
    "years": "Jahre",
    "euro": "Euro",

    "login": "Login",
    "login.forgotpassword": `Passwort vergessen?`,
    "username": "Username",
    "password": "Passwort",
    "password.change": "Passwort ändern",
    "password.requestSent": "Passwort Reset E-Mail wurde versandt",
    "interestRatesSent": "Daten wurden gespeichert",

    "title": "Titel",
    "mr": "Herr",
    "mrs": "Frau",
    "dr.": "Dr.",
    "prof.": "Prof.",
    "prof.dr.": "Prof.Dr.",
    "salutation": "Anrede",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "addressCountry": "Länderanschrift",
    "address": "Straße, Hausnummer",
    "zipCode": "PLZ",
    "residence": "Wohnort",
    "zipCodeAndResidence": "PLZ, Wohnort",
    "birthDate": "Geburtsdatum (TT.MM.JJJJ)",
    "birthName": "Geburtsname",
    "ownAccord": "Ich handle / Wir handeln im eigenen wirtschaftlichen Interesse und nicht auf fremde Veranlassung (insbes. als Treuhänder)",
    "germany": "Deutschland",
    "downloadHistory": "History herunterladen",
    "currentInterestRates": "Aktuell gültige Zinsen",
    "upcomingInterestRates": "Neue Zinsen",

    "secondBorrower": "2. Kreditnehmer?",
    "secondBorrowerSpouse": "Ehepartner als 2. Kreditnehmer?",
    "secondBorrowerEmployment": "Beschäftigungsdaten für ",

    "maritalStatus": "Familienstand",
    "peopleInHousehold": "Anzahl Personen im Haushalt",
    "residenceStatus": "Wohnstatus",
    "residenceSince": "Wohnhaft in {address} seit (TT.MM.JJJJ)",
    "citizenship": "Staatsangehörigkeit",
    "employment": "Art der Beschäftigung",
    "job": "Berufsbezeichnung",
    "employer": "Arbeitgeber",
    "employedSince": "Beim Arbeitgeber beschäftigt seit (TT.MM.JJJJ)",

    "marital.single": "ledig",
    "marital.married": "verheiratet",
    "marital.separated": "getrennt lebend",
    "marital.divorced": "geschieden",
    "marital.widow": "verwitwet",
    "marital.partnership": "Lebenspartnerschaft",

    "residence.owner": "Eigentum",
    "residence.rent": "Miete",
    "residence.atParents": "bei den Eltern",
    "residence.detail": `Ergänzung zu Wohnstatus`,

    "employment.employee": "Angestellter",
    "employment.worker": "Arbeiter",
    "employment.civilServant": "Beamter",
    "employment.retired": "Rentner",
    "employment.private": "Privatier",
    "employment.other": "sonstige (z.B. Student, Hausfrau)",
    "employment.detail": `Ergänzung zu Beschäftigung`,

    "header.loan": "SpardaModernisierungsdarlehen",
    "header.loan.mobile": "Modernisierungs-<br/>darlehen",
    "header.baseData": "Persönliches",
    "header.taxData": "Steuerdaten",
    "header.contactInformation": "Kontaktinformation",
    "header.income": "Monatliche Einnahmen in Euro",
    "header.income.secondBorrower": "Nettoeinkommen",
    "header.expenses": "Monatliche Ausgaben in Euro",
    "header.summary": "Zusammenfassung",
    "header.interestRates": "Zinsen nach Laufzeit",
    "header.login": "Login",
    "header.success": "Vielen Dank!",
    "header.secondBorrower": "Zweiter Kreditnehmer",
    "header.ownerOfObject": "Eigentümer von Objekt",
    "header.employment": "Beschäftigungsdaten",
    "header.documents": "Unterlagen",
    "header.climatebonus": "SpardaKlimaBonus",
    "header.requestPassword": `Passwort zurücksetzen`,

    "password.password": `Neues Passwort`,
    "password.textField": `Neues Passwort (mind. 6 Zeichen)`,
    "password.repeat": `Passwort wiederholen`,
    "password.mismatch": `Passwort ungleich`,
    "password.tooShort": `Mindestens 6 Zeichen`,
    "password.action": `Übernehmen`,

    "stepper.baseData": "Persönliches",
    "stepper.contactInformation": "Kontakt",
    "stepper.income": "Einnahmen",
    "stepper.expenses": "Ausgaben",
    "stepper.documents": "Unterlagen",
    "stepper.summary": "Zusammenfassung",

    "loan.amount": "Kreditwunsch",
    "loan.amountSubtitle": "(Nettodarlehensbetrag)",
    "loan.amountSubtitleValues": "(Nettodarlehensbetrag, mind. {minAmount})",
    "loan.duration": "Laufzeit",
    "loan.durationInYears": "Laufzeit in Jahren",
    "loan.durationOneYear": "1 Jahr",
    "loan.durationYears": "{duration} Jahre",
    "loan.request": "Jetzt anfragen",
    "loan.amountTotal": "Gesamtbetrag",
    "loan.monthlyRate": "Monatsrate",
    "loan.methodValues": "Werte eingeben",
    "loan.methodSliders": "Schieberegler",
    "loan.amountHint": "Betrag in Euro",
    "loan.durationHint": "Laufzeit in Jahren",
    "loan.amountError": "Ungültiger Betrag",
    "loan.amountTooSmall": "Betrag zu niedrig",
    "loan.amountTooBig": "Betrag zu hoch",
    "loan.durationError": "Ungültige Laufzeit",
    "loan.interestRate": "Sollzinssatz p.a.",
    "loan.interestRateEffective": "Effektivzinssatz p.a.",
    "loan.minAmount": "min. Nettodarlehensbetrag in Euro",
    "loan.maxAmount": "max. Nettodarlehensbetrag in Euro",
    "loan.minDuration": "min. Laufzeit in Jahren",
    "loan.maxDuration": "max. Laufzeit in Jahren",

    "contact.phoneNumber": "Telefonnummer privat",
    "contact.phoneNumber.info": "Ihre Telefonnummer nutzen wir bei Rückfragen.",
    "contact.emailAddress": "E-Mail Adresse privat",
    "contact.emailAddress.info": "An Ihre E-Mail Adresse schicken wir Ihnen wichtige Unterlagen und Informationen zu Ihrem Modernisierungsdarlehen.",
    "contact.phoneAllowed": "Telefonberatung",
    "contact.iban": "Bankverbindung: IBAN",
    "contact.iban.info": "Ihre IBAN zur Auszahlung des Darlehen und Abbuchung der monatlichen Raten.",

    "tax.userIsAmerican": "Der Kontoinhaber/Treugeber ist eine natürliche Person und Staatsangehöriger der Vereinigten Staaten von Amerika",
    "tax.userTaxedAmerican": "Der Kontoinhaber/Treugeber ist eine natürliche Person und in den Vereinigten Staaten von Amerika steuerlich ansässig",
    "tax.userTaxedForeigner": "Der Kontoinhaber/Treugeber ist in einem Auslandsstaat (außer Deutschland und den Vereinigten Staaten von Amerika) steuerlich ansässig?",

    "income.net": "Nettoeinkommen (ohne Kindergeld)",
    "income.net.secondBorrower": "Nettoeinkommen, ",
    "income.childMoney": "Kindergeld",
    "income.rent": "Einkünfte aus Vermietung und Verpachtung (Kaltmiete)",
    "income.other": "Nebeneinkünfte / Sonstige Einkünfte",
    "income.otherDescription": "Beschreibung der Einkünfte",

    "expenses.rent": "Miete",
    "expenses.utilities": "Haus / Wohnung Nebenkosten (z.B. Versicherung, Wasser)",
    "expenses.otherLoans": "Bestehende Finanzierungsraten für andere laufende Kredite",
    "expenses.insurances": "Versicherungsbeiträge",
    "expenses.haveHealthInsurance": "Sind Sie privat krankenversichert?",
    "expenses.healthInsurance": "Private Krankenversicherung monatlich",
    "expenses.numberOfCars": "Anzahl PKW",
    "expenses.other": "Sonstige Aufwendungen / Unterhalt",
    "expenses.otherDescription": "Beschreibung der Aufwendungen",

    "summary.attachments": `Anhänge`,
    "summary.attachmentsMising": `Bitte Ausweis und Gehaltsnachweise anhängen.`,
    "summary.attachments.personalId": `Personalausweis Vor-/Rückseite`,
    "summary.attachments.payslips": `3 letzte Gehaltsnachweise`,
    "summary.attachments.rentUpload": `Mietaufstellung`,
    "summary.attachments.dragOrChoose": `Datei auswählen oder hierher ziehen, jpg oder pdf (max 10MB)`,
    "summary.attachments.tooBig": `Datei ist zu groß. Die maximale Dateigröße beträgt 10MB.`,
    "summary.climatebonus": `Ich möchte den SpardaKlimaBonus nutzen und verwende das Darlehen für energetische Maßnahmen an meiner Immobilie.`,
    "summary.requirement": `Ich nutze das Darlehen zur Modernisierung meiner eigenen Immobilie`,
    "summary.termsAndConditions.part1": `Ich habe die `,
    "summary.termsAndConditions.part2": `rechtlichen Hinweise`,
    "summary.termsAndConditions.part3": ` gelesen und bin einverstanden`,
    "summary.gdpr": `Datenschutzhinweise`,
    // "summary.gdpr": `Ich habe die <a href={gdprUrl} target="_blank">Datenschutzhinweise</a> gelesen und bin einverstanden</a>`,
    "summary.acknowledgements": `Zustimmungen`,
    "summary.attachmentInvalid.title": `Dateifehler`,
    "summary.attachmentInvalid.message": `Es sind nur Bild-Dateien und Dokumente mit folgenden Endungen erlaubt: jpg, pdf. Maximale Dateigröße 10MB.`,
    "summary.attachmentExists.title": `Duplikat`,
    "summary.attachmentExists.message": `Sie haben diese Datei schon angehängt.`,
    "summary.creditInformation": `Ich bin / Wir sind mit einer SCHUFA-Auskunft zur Beantragung dieses Kreditantrages einverstanden`,
    "summary.tax": `Ich bestätige, dass ich ausschließlich in Deutschland steuerlich ansässig
        und kein Staatsangehöriger der Vereinigten Staaten von Amerika bin`,
    "summary.send": `Jetzt Antrag absenden`,
    "summary.ownerOfObject": `Ich bestätige, dass ich Eigentümer des folgenden Objekts bin und
        ermächtige die Sparda-Bank Hessen eG einen Grundbuchauszug beim Grundbuchamt (OLG Hessen) anzufordern.`,
    "objectDistrictCourt": "Amtsgericht in",
    "objectRegister": "Grundbuch von",
    "objectSheetNumber": "Blatt Nr.",
    "uploadNow": "Jetzt hochladen",

    "success.thankYou": `
        Vielen Dank, {name}.<br />
        Wir haben Ihre Daten erhalten.
    `,
    "success.message": `
        <h2>So geht es weiter</h2>
        <p>
        Einer unserer erfahrenen Baufinanzierungsberater wird Ihre Daten prüfen und sich innerhalb der nächsten drei Arbeitstage bei Ihnen melden. 
        Während der Bearbeitung bleibt Ihr Zinssatz 7 Tage gebunden. Alle weiteren Informationen zur Vorgehensweise erhalten Sie direkt von Ihrem Berater. 
        </p>
        <p>
        Bei weiteren Fragen erreichen Sie unseren Kundenservice an Wochentagen von 8 bis 18 Uhr unter:
        </p>
        <p style="text-align:center;font-weight:bold;">069/7537-850 *</p>
        <p>* zum Ortstarif aus dem dt. Festnetz, über Mobilfunk abhängig von Ihrem Anbieter</p>
    `,
    "product.info.text": "Für Ihre Kreditanfrage benötigen wir folgende Unterlagen von Ihnen: ",
    "product.info.documents": `
        <br/><br/>
        <li>Personalausweis</li>
        <li>Die letzten 3 Gehaltsnachweise</li>
        <li>Grundbuchauszug</li>
        <li>ggfs. Mietaufstellung</li>
        <br/>
        <br/>
    `,


    "bottomBar.legal": "Impressum",
    "bottomBar.termsOfUse": "Nutzungsbedingungen",
    "bottomBar.data": "Datenschutz",
    "bottomBar.deposit": "Einlagensicherung",
    "bottomBar.conditions": "AGB",
    "bottomBar.prices": "Preise",
    "bottomBar.sparda": "Sparda-Bank Hessen eG",

    // "infoBox.header": "SpardaModernisierungsdarlehen",
    // "infoBox.darlehen": `Ein Darlehen – viele Möglichkeiten: <br /> besonders einfach und günstig, ohne Grundbuchabsicherung!`,
    // "infoBox.aufEinenBlick": "Auf einen Blick:",
    // "infoBox.list.immo": "für Immobilienbesitzer",
    // "infoBox.list.laufzeit": "bis zu 15 Jahre Laufzeit",
    // "infoBox.list.zusage": "Zusage innerhalb von drei Tagen",
    // "infoBox.list.auszahlung": "Auszahlung nach Vertragsunterschrift",

    "gdpr.accepted": "Datenschutzhinweise wurden gelesen und akzeptiert",

    "hint.effectiveRateLogoUsed": "Der Effektivzins von Beispiel 2 wird in der Grafik auf der Startseite angezeigt.",

    "representativeExample.title": "Repräsentatives Beispiel gemäß § 6a PAngV für ein Allgemein-Verbraucherdarlehen",
    "representativeExample": "Repräsentatives Beispiel gemäß § 6a PAngV für ein Allgemein-Verbraucherdarlehen: Nettodarlehensbetrag: {amount}",
    "representativeExample.amount": "Nettodarlehensbetrag",
    "representativeExample.header.duration": "Sollzinsbindung (Laufzeit)",
    "representativeExample.header.duration.example": "{duration} Jahre - Volltilgung",
    "representativeExample.payOut": "Empfang (Auszahlung)",
    "representativeExample.initial": "anfängliche Tilgung",
    "representativeExample.interest": "fester Sollzinssatz",
    "representativeExample.interestEffective": "effektiver Jahreszins",
    "representativeExample.monthlyRate": "monatliche Rate",
    "representativeExample.numRates": "Anzahl der Raten",
    "representativeExample.total": "Zu zahlender Gesamtbetrag (Volltilgung)",
    "representativeExample.total.short": "Gesamtbetrag",

    "bulletPoint.header.title": "Heute beantragt - innerhalb von 3 Tagen entschieden",
    "bulletPoint.header.reference.title": "Verwendungszweck: ",
    "bulletPoint.header.reference.description": "Modernisierung einer eigenen Immobilie",
    "bulletPoint.header.loanAmount.title": "Darlehensbetrag: ",
    "bulletPoint.header.loanAmount.description": "optional zwischen {minAmount} und {maxAmount}",
    "bulletPoint.header.refund.title": "Rückzahlung: ",
    "bulletPoint.header.refund.description": "Annuitätendarlehen, Rückzahlung in monatlichen Raten (Zins + Tilgung)",
    "bulletPoint.header.duration.title": "Laufzeit: ",
    "bulletPoint.header.duration.description": "optional von {minDuration} bis {maxDuration} Jahren (vollständige Rückzahlung im gewählten Zeitraum)",
    "bulletPoint.header.sollBinding.title": "Sollzinsbindung: ",
    "bulletPoint.header.sollBinding.description": "entspricht der Laufzeit – das gibt Ihnen optimale Planungssicherheit",
    "bulletPoint.header.securities.title": "Sicherheiten: ",
    "bulletPoint.header.securities.description": "ohne grundpfandrechtliche Besicherung",
    "bulletPoint.header.repayment.title": "Sondertilgung: ",
    "bulletPoint.header.repayment.description": "kostenlose Sondertilgungen jederzeit möglich",
    "bulletPoint.header.climatebonus.title": "SpardaKlimaBonus*: ",
    "bulletPoint.header.climatebonus.description": "bis zu 500 EUR für folgende energieeffiziente Maßnahmen:",
    "bulletPoint.header.climatebonus.listitems": `
        <li>Wärmedämmung des Daches, der Außenwände, des Kellers sowie der Geschossdecken</li>
        <li>Erneuerung der Heizungsanlage auf Basis erneuerbarer Energien</li>
        <li>Installation einer Photovoltaikanlage/Speichers</li>
        <li>Austausch der Fenster/Haustür</li>
        <li>Solarkollektoren (Solarthermie)</li>
    `,
    /* tslint:disable-next-line:max-line-length */
    "bulletPoint.bottomparagraph": `* 1&nbsp;% des Darlehenbetrages, max. 500&nbsp;EUR werden Ihnen als Klimabonus für die Durchführung energetischer Maßnahmen auf Ihrem Ratenabrechnungskonto gutgeschrieben. Für die Auszahlung des Bonus müssen mind. 75&nbsp;% des Darlehensbetrages für die o.g. Maßnahmen verwendet werden (Nachweis erforderlich).`
};

export type IAvailableI18nIds = typeof locale;
export default locale;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n/de.ts